import React from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';
import moment from 'moment';
import axios from './../../../constants/axios';

class UnknownUnpaidBill extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         unpaidBills: []
      };
   }

   componentDidMount() {
      axios.get('inventorySales/saleUnknownDueBills')
         .then((res) => {
            this.setState({
               unpaidBills: res.data
            });
         });
   }

   render() {
      const { unpaidBills } = this.state;
      return (
         <Table >
            <thead >
            <tr >
               <th >#inv Id</th >
               <th >Contact Name</th >
               <th >Amount</th >
               <th >Paid</th >
               <th >Due</th >
               <th >Inv Created</th >
               <th >##</th >
            </tr >
            </thead >
            <tbody >
            {unpaidBills.map((bill) => (
               <tr key={bill.id} >
                  <td >{bill.id}</td >
                  <td >{bill.contact_name}</td >
                  <td >{bill.total_amount}</td >
                  <td >{bill.paid_amount}</td >
                  <td >{bill.due}</td >
                  <td >{moment(bill.created_at).format('DD/MM/YYYY h:mm a')}</td >
                  <td >
                     <Link to={`/sale/saleInvoiceDetail/${bill.id}`} >Details</Link >
                     <Link to={`/sale/saleReceivePayment/${bill.id}`} >Receive Payment</Link >
                  </td >
               </tr >
            ))}
            </tbody >
         </Table >
      );
   }
}

export default UnknownUnpaidBill;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/UnknowUnpaidBill.js
 **/